import { useEffect, useState } from 'react'
import MangaViewer from '../manga/MangaViewer';
import { Helmet } from "react-helmet";
import { getFormattedDate } from '../../helpers/dates';
import { getLatestStuff } from '../../helpers/firestore';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
// import { Link } from 'react-router-dom';
// import { atFolder } from '../../constants/cdn';

// // Get images for links
// const images = atFolder('granbluedle/etc');

const HomeScreen = () => {

    const [manga, setManga] = useState(null);
    const [other, setOther] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [showLewd, setShowLewd] = useState(false)

    useEffect(() => {
        // Load from database database woah woah
        getLatestStuff()
            .then((returnedManga) => {
                setManga(returnedManga);
            })
            .catch((error) => {
                const errorElement = (
                    <div className="alert alert-danger">
                        There was an error while reading from the database. <br />
                        It wasn't possible to get the latest registered manga, for some reason. <br />
                        Send me a screenshot of this code and I might be able to do something about it: {`${error}`}
                    </div>
                )
                setErrorMessage(errorElement);
            })
        getLatestStuff(true)
            .then((returnedOther) => {
                setOther(returnedOther);
            })
            .catch((error) => {
                const errorElement = (
                    <div className="alert alert-danger">
                        There was an error while reading from the database. <br />
                        It wasn't possible to get the latest registered manga, for some reason. <br />
                        Send me a screenshot of this code and I might be able to do something about it: {`${error}`}
                    </div>
                )
                setErrorMessage(errorElement);
            })
    }, [])

    return (
        <>
            <Helmet>
                <title>RudyTudySubs</title>
            </Helmet>
            <div className="d-flex">
                <h1>Welcome to the RudyTudySubs website!</h1>
                <small> ^ Use the bar above</small>
            </div>
            <div className="alert alert-primary d-flex flex-column">
                <p className="mb-0">
                    <b>News 29/12/2025: Added a new section for non-manga releases.</b>
                </p>
                <p className="mb-0">Just a regular section for other stuff I've worked on.</p>
            </div>
            {
                other
                &&
                <div className="alert alert-info">
                    <Link to={`/other/${other.id}`}>
                        Latest non-manga update: {getFormattedDate(other.date)} - {other.name}
                    </Link>
                </div>
            }
            {
                manga
                &&
                <div className="alert alert-info">
                    <Link to={`/manga/${manga.id}`}>
                        Latest manga update: {getFormattedDate(manga.date)} - {manga.name}
                    </Link>
                </div>
            }
            <div className="container mt-3">
                {
                    manga
                        ?
                        <>
                            {
                                manga.lewd
                                    ?
                                    showLewd
                                        ?
                                        <MangaViewer manga={manga} />
                                        :
                                        <Button
                                            variant="contained"
                                            fullWidth
                                            color="secondary"
                                            onClick={() => { setShowLewd(true) }}
                                        >
                                            NSFW WARNING - Uwah actually this is pretty lewd, sure you wanna see it?
                                        </Button>
                                    :
                                    <MangaViewer manga={manga} />
                            }

                        </>
                        :
                        errorMessage
                            ?
                            <>
                                {errorMessage}
                            </>
                            :
                            <>
                                <div className="alert alert-secondary">Loading...</div>
                            </>
                }
            </div>
        </>
    )
}

export default HomeScreen;